import React, {FC, ReactElement} from "react";

interface Props {
  withBorder?: boolean
  className?: string
  children: ReactElement | ReactElement[]
}

const RightBigPanelHeader: FC<Props> = (props) => {
  return (
    <div id='bigPanel-header'
         className={`
         ${props.withBorder ? 'bottom-border' : ''}
         ${props.className ? props.className : ''}
         `}>
      {props.children}
    </div>
  )
}

export default RightBigPanelHeader
